"use client"

import { formatMenuUrl, isExternalLink, normalizeUrl } from "@/utils/ensure-protocol-helper"
import Link from "next/link"

interface MenuSubItemProps {
  subItem: {
    url: string
    title: string
  }
  locale: string
  className?: string
  onClick?: () => void
}

export const MenuSubItem = ({ subItem, locale, className, onClick }: MenuSubItemProps) => {
  const subItemUrl = subItem.url || '/'
  const normalizedSubUrl = normalizeUrl(subItemUrl)
  const subFinalUrl = formatMenuUrl(normalizedSubUrl, locale)
  const isSubExternal = isExternalLink(normalizedSubUrl)

  if (isSubExternal) {
    return (
      <a
        href={subFinalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={onClick}
      >
        {subItem.title}
      </a>
    )
  }

  return (
    <Link href={subFinalUrl} className={className} onClick={onClick}>
      {subItem.title}
    </Link>
  )
}
